import { Injectable, inject } from '@angular/core';

import { GoToOptions, NavigationService, ProductService } from '@frontend/vanilla/core';

@Injectable({
    providedIn: 'root',
})
export class PortalNavigationService {
    private navigation = inject(NavigationService);
    private productService = inject(ProductService);

    private getBaseUrl(url: string): string {
        const basePath = this.productService.isSingleDomainApp ? 'myaccount' : 'mobileportal';
        return `/${basePath}${url}`;
    }

    navigate(url: string, options?: GoToOptions): Promise<any> {
        // const basePath = this.productService.isSingleDomainApp ? 'myaccount' : 'mobileportal';
        return this.navigation.goTo(this.getBaseUrl(url), options);
    }
    normalizeUrl(input: string): string {
        return this.getBaseUrl(input);
    }
}
